import * as ACTION_TYPES from '../actions/action_type';

const initialState = {
    users: [],
    user: null,
    loading: false,
    errors: null,
};

const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTION_TYPES.GET_USERS:
            return {...state, loading: true};
        case ACTION_TYPES.GET_USERS_SUCCESS:
            return {...state, users: action.payload, loading: false};
        case ACTION_TYPES.GET_USER:
            return {...state, user: action.payload, loading: false};
        case ACTION_TYPES.UPDATE_USER:
            return {...state, user: action.payload, loading: false};
        case ACTION_TYPES.DISABLE_USER:
            return {...state, user: action.payload, loading: false};
        case ACTION_TYPES.ENABLE_USER:
            return {...state, user: action.payload, loading: false};
        case ACTION_TYPES.DELETE_USER:
            return {...state, user: null, loading: false};
        case ACTION_TYPES.CHANGE_PASSWORD:
            return {...state, user: action.payload, loading: false};
        case ACTION_TYPES.RESET_PASSWORD:
            return {...state, user: action.payload, loading: false};
        case ACTION_TYPES.SET_ERRORS:
            return {...state, error: action.payload, loading: false};
        default:
            return state;

    }
}

export default userReducer;
